<div class="flex justify-between mt-4 font-light text-xs pr-6 font-italic">
  <div class="flex-1">
    <span>{{ 'Availability' | translate }}</span>
  </div>
  <span class="flex-1">
    {{ availability.description }}
  </span>
</div>
